import _ from "lodash";
import React from "react";
import classes from "./TagStudents.scss";
import ScreenPanel from "../../ScreenPanel";
import { SearchInput, Button, IconButton } from "@toddle-edu/ds-web";
import I18nHOC from "UIComponents/I18nHOC";
import UIModal from "UIComponents/UIModal";
import { connect } from "react-redux";
import { graphql, compose } from "lib/apolloClient";
import { getCourseFilteredStudentQuery } from "Post/modules/PostQuery";
import StudentList from "./StudentList";
import { getCourseFilteredStudentFromCache } from "Post/modules/PostGraphqlHelpers";
import { updateStudentListFilters } from "Post/modules/PostModule";
import { getUpdatedArchivedFilters } from "Utils";
import {
  compareRatingObjects,
  removeSingleActivity,
  showActivityTracking,
  isPortfolioParityEnabled,
} from "AppComponents/Post/utils";
import { CloseOutlined, TickCircleFilled } from "@toddle-edu/ds-icons";
import {
  getDefaultNameSortPreference,
  getCurrentCurriculumProgramType,
  getSelectedAcademicYearId,
} from "modules/CommonSelectors";
import { ASC, STUDENT } from "Constants/stringConstants";
import { colors } from "Constants";
import { hasIncludeGivenPathInCurrentRoute } from "Teacher/routes/Courses/routes/Course/routes/UnitPlans/routes/UnitPlanDetails/routes/EditUnitPlan/routes/IBPlanner/modules/IBPlannerModule";
import { getDefaultOrderBy } from "Utils/GetFormattedUserName";
const styles = {
  headerContainerStyle: { padding: "0 24px 0 32px" },
  modalHeaderContainerStyle: { marginBottom: "8px" },
};

const BLANK_OBJECT = {};
const FooterComponent = React.memo(props => {
  const {
    onDoneClick,
    selectedStudentIds,
    onCloseClick,
    showStudentCount = true,
    t,
    showNewDesign,
    curriculumProgramType,
    showNewDesignV2,
    cancelButtonRef,
  } = props;
  const countString = t("journal:studentSelected", {
    count: _.compact(selectedStudentIds).length,
  });

  return (
    <div className={classes.footerButtonContainer}>
      {!showNewDesign || showNewDesignV2 ? (
        <div
          className={classes.footerText}
          style={{
            fontWeight: isPortfolioParityEnabled() ? "600" : "",
          }}
          data-test-id={"journal-postcreation-taggedstudents-count"}
        >
          {showStudentCount ? countString : ""}
        </div>
      ) : null}
      <div
        className={classes.footerButtons}
        style={showNewDesign ? { alignSelf: "end" } : {}}
      >
        <Button
          dsVersion="2.0"
          ref={cancelButtonRef}
          size={"large"}
          onClick={onCloseClick}
          type="outlined"
          variant="neutral"
          style={{ marginRight: "12px" }}
          testId={"journal-postcreation-tagstudents-cancel"}
        >
          {t("common:cancel")}
        </Button>
        <Button
          dsVersion="2.0"
          size={"large"}
          onClick={onDoneClick}
          variant="progressive"
          icon={showNewDesign && !showNewDesignV2 ? <TickCircleFilled /> : null}
          testId={"journal-postcreation-tagstudents-done"}
        >
          {t("common:done")}
        </Button>
      </div>
    </div>
  );
});

FooterComponent.displayName = "FooterComponent";
class TagStudents extends React.PureComponent {
  constructor(props) {
    super(props);
    this.studentListRef = React.createRef(null);
    this.containerRef = React.createRef(null);
    this.cancelButtonRef = React.createRef(null);
    this.containerRef = React.createRef();
    const selectedStudents = _.get(
      props.screenPanelProps,
      "postDetails.students.edges",
      []
    );

    const selectedStudentIds = _.map(selectedStudents, item => {
      return item.node.id;
    });

    this.state = {
      prevSelectedStudentIds: selectedStudentIds,
      selectedStudentIds: _.compact(selectedStudentIds),
      showUntagWarningModal: false,
      studentsToUntag: [],
    };
  }

  componentDidMount() {
    if (this.studentListRef?.current) {
      this.studentItems =
        Array.from(
          this.studentListRef?.current?.querySelectorAll(
            'input[type="checkbox"]'
          )
        ) ?? [];
    }
    if (this.containerRef) {
      this.containerRef.current?.addEventListener(
        "keydown",
        this.handleKeyDown
      );
    }
  }

  componentDidUpdate() {
    if (this.studentListRef?.current && !this.studentItems) {
      this.studentItems =
        Array.from(
          this.studentListRef?.current?.querySelectorAll(
            'input[type="checkbox"]'
          )
        ) ?? [];
    }
  }

  stopPropagationAndPreventDefault = event => {
    event.preventDefault();
    event.stopPropagation();
  };

  handleKeyDown = event => {
    const { key } = event;

    if (key === "Tab" && this.studentItems?.includes(document.activeElement)) {
      this.stopPropagationAndPreventDefault(event);
      this.cancelButtonRef?.current?.focus();
    }
    if (
      (key === "ArrowDown" || key === "s") &&
      this.studentItems?.includes(document.activeElement)
    ) {
      this.stopPropagationAndPreventDefault(event);
      const currentIndex = this.studentItems.indexOf(document.activeElement);
      if (currentIndex < this.studentItems.length - 1) {
        this.studentItems[currentIndex + 1]?.focus();
      } else {
        _.first(this.studentItems)?.focus();
      }
    }
    if (
      (key === "ArrowUp" || key === "w") &&
      this.studentItems?.includes(document.activeElement)
    ) {
      this.stopPropagationAndPreventDefault(event);
      const currentIndex = this.studentItems.indexOf(document.activeElement);
      if (currentIndex > 0) {
        this.studentItems[currentIndex - 1]?.focus();
      } else {
        _.last(this.studentItems)?.focus();
      }
    }
  };

  onSearchTextChange = value => {
    const { updateStudentListFilters } = this.props;
    updateStudentListFilters({ searchText: value });
  };

  isAllSelected = () => {
    const { students = [] } = this.props;
    const { selectedStudentIds } = this.state;

    return (
      _.get(
        _.intersection(
          selectedStudentIds,
          _.map(students, item => item.node.id)
        ),
        "length",
        0
      ) == students.length
    );
  };

  onItemCheckBoxClick = item => {
    const {
      students,
      userInfo: { id: userId, user_type: userType },
      studentSelectionMode,
      createdBy,
    } = this.props;
    const { selectedStudentIds } = this.state;
    let updatedSelectedStudentIds = [];

    if (item.id == "ALL") {
      const isAllSelected = this.isAllSelected();
      // if not student uncheck all checkboxes otherwise  uncheck all except the student's checkox
      if (isAllSelected) {
        updatedSelectedStudentIds =
          userType == "student"
            ? [userId]
            : isPortfolioParityEnabled()
            ? [_.get(createdBy, "id")]
            : [];
      } else {
        updatedSelectedStudentIds = _.map(students, item => {
          return item.node.id;
        });
      }
    } else {
      const isChecked = _.includes(selectedStudentIds, item.id);

      // Make sure the selectedStudentId list doesn't update when user clicks on its own checkbox
      if (isChecked) {
        updatedSelectedStudentIds =
          userType == "student" && userId == item.id
            ? selectedStudentIds
            : _.isEqual(studentSelectionMode, "SINGLE")
            ? []
            : _.filter(selectedStudentIds, id => id != item.id);
      } else {
        if (_.isEqual(studentSelectionMode, "SINGLE")) {
          updatedSelectedStudentIds = [item.id];
        } else {
          updatedSelectedStudentIds = [...selectedStudentIds, item.id];
        }
      }
    }

    this.setState({ selectedStudentIds: updatedSelectedStudentIds });
  };

  onDoneClick = () => {
    this.props.updateStudentListFilters({ searchText: "" });
    setTimeout(() => {
      const {
        students,
        postIbPypElementRatings,
        isStudentIndividuallyRated,
      } = this.props;
      const { selectedStudentIds, prevSelectedStudentIds } = this.state;

      const removedStudents = _.differenceWith(
        prevSelectedStudentIds,
        selectedStudentIds,
        _.isEqual
      );
      let showChangesWarning = false;
      if (
        _.size(removedStudents, 0) > 0 &&
        (isStudentIndividuallyRated || _.size(students, 0) == 1)
      ) {
        _.forEach(removedStudents, removedStudentId => {
          if (
            _.find(
              postIbPypElementRatings,
              rating =>
                removedStudentId ==
                _.get(
                  rating,
                  "studentId",
                  _.get(rating, "student.id", undefined)
                )
            )
          ) {
            showChangesWarning = true;
          }
        });
      }

      if (!showChangesWarning) {
        this.updatePostState();
      } else {
        this.setState({
          showUntagWarningModal: true,
          studentsToUntag: _.filter(students, student =>
            _.includes(removedStudents, _.get(student, "node.id", undefined))
          ),
        });
      }
    });
  };

  updatePostState = () => {
    const {
      screenPanelProps: { updatePost, onCloseClick } = {},
      students,
      postIbPypElementRatings,
      isStudentIndividuallyRated,
      studentActivityData,
    } = this.props;
    const { selectedStudentIds, prevSelectedStudentIds } = this.state;

    const selectedStudent = [];
    _.forEach(students, item => {
      if (_.includes(selectedStudentIds, item.node.id)) {
        selectedStudent.push(item);
      }
    });
    const studentsEmpty = _.get(selectedStudent, "length", 0) == 0;

    let privateState = {};

    //Here we will not update the isPrivate and isHiddenFromStudents in case prev and new tagged student
    // are more than one

    if (!(prevSelectedStudentIds.length > 0 && selectedStudentIds.length > 0)) {
      privateState = {
        isPrivate: studentsEmpty,
        isHiddenFromStudents: studentsEmpty,
      };
    }

    const updatedRatings = _.filter(
      postIbPypElementRatings,
      rating =>
        _.find(
          selectedStudent,
          student =>
            student.node.id ==
            _.get(rating, "studentId", _.get(rating, "student.id"))
        ) != undefined
    );

    // Copy ratings for new added student(s), only for collective mode
    const newAddedStudentsIds = _.differenceWith(
      selectedStudentIds,
      prevSelectedStudentIds,
      _.isEqual
    );

    const removedStudentsIds = _.differenceWith(
      prevSelectedStudentIds,
      selectedStudentIds,
      _.isEqual
    );

    if (isStudentIndividuallyRated === false) {
      if (_.size(newAddedStudentsIds, 0) > 0) {
        const uniqueRatings = _.uniqWith(updatedRatings, (rating1, rating2) => {
          return compareRatingObjects({
            rating1,
            rating2,
            shouldCompareStudent: false,
          });
        });
        if (_.size(uniqueRatings, 0) > 0) {
          _.forEach(newAddedStudentsIds, newStudentId => {
            updatedRatings.push(
              ..._.map(uniqueRatings, rating => {
                const cloneRating = _.cloneDeep(rating);
                cloneRating.studentId = newStudentId;
                return cloneRating;
              })
            );
          });
        }
      }
    }

    // Copy Student activity properties from common tab (if available) for newly added student(s)
    let updatedStudentActivities = {};
    if (showActivityTracking()) {
      updatedStudentActivities = _.cloneDeep(studentActivityData);
      if (!_.isNil(_.get(updatedStudentActivities, "ALL")))
        _.forEach(newAddedStudentsIds, newStudentId => {
          _.setWith(
            updatedStudentActivities,
            [newStudentId],
            _.cloneDeep(_.get(updatedStudentActivities, "ALL")),
            Object
          );
        });
      _.forEach(removedStudentsIds, removedStudentId => {
        updatedStudentActivities = removeSingleActivity({
          studentIds: selectedStudentIds,
          studentId: removedStudentId,
          currentStudentActivities: updatedStudentActivities,
          key: [],
        });
      });
    }

    if (
      _.size(prevSelectedStudentIds, 0) > 0 &&
      _.size(selectedStudentIds, 0) == 0 &&
      _.size(updatedRatings, 0) == 0
    ) {
      // if all students are removed, reset rate on learning goals supportive states. also reset student activity details
      updatePost({
        students: { edges: selectedStudent },
        ...privateState,
        ibPYPElementRatings: [...updatedRatings],
        originalibPYPElementRatings: [...updatedRatings],
        isStudentIndividuallyRated: false,
        originalIsStudentIndividuallyRated: false,
        currentSelectedStudentForRating: {},
        studentActivityData: {
          activityType: _.get(studentActivityData, "activityType"),
        },
      });
    } else {
      updatePost({
        students: { edges: selectedStudent },
        ...privateState,
        ibPYPElementRatings: [...updatedRatings],
        originalibPYPElementRatings: [...updatedRatings],
        studentActivityData: updatedStudentActivities,
      });
    }
    onCloseClick();
  };

  getFooterStyle = () => {
    const isJournalRoute = hasIncludeGivenPathInCurrentRoute({
      path: "/journal",
    });
    return isJournalRoute
      ? { boxShadow: "none", borderTop: `1px solid ${colors.borderSubtle}` }
      : {};
  };

  render() {
    const {
      screenPanelProps,
      isData,
      isLoading,
      students,
      filters,
      userInfo,
      t,
      studentSelectionMode,
      curriculumProgramType,
    } = this.props;
    const {
      selectedStudentIds,
      showUntagWarningModal,
      studentsToUntag,
    } = this.state;
    const searchText = _.get(filters, "searchText", "");
    const isAllSelected = this.isAllSelected();
    return (
      <ScreenPanel
        {...screenPanelProps}
        containerStyle={{ padding: "0 32px" }}
        titleContainerStyle={{ marginTop: "30px" }}
        closeOnOutSideClick={!showUntagWarningModal}
        parentContainerRef={this.containerRef}
        footerComponent={
          !(_.isEmpty(students) && !searchText) && (
            <FooterComponent
              cancelButtonRef={this.cancelButtonRef}
              t={t}
              onDoneClick={this.onDoneClick}
              onCloseClick={
                !_.isUndefined(screenPanelProps?.onCloseClick) &&
                screenPanelProps?.onCloseClick
              }
              selectedStudentIds={selectedStudentIds}
              showStudentCount={_.isEqual(studentSelectionMode, "MULTIPLE")}
              showNewDesign={_.get(screenPanelProps, "showNewDesign", false)}
              curriculumProgramType={curriculumProgramType}
              showNewDesignV2={_.get(
                screenPanelProps,
                "showNewDesignV2",
                false
              )}
            />
          )
        }
        titleTextStyle={{ fontSize: "2rem" }}
        footerContainerStyle={{
          height: "96px",
          ...(isPortfolioParityEnabled() && this.getFooterStyle()),
        }}
        headerContainerStyle={
          isPortfolioParityEnabled()
            ? styles.headerContainerStyle
            : BLANK_OBJECT
        }
        modalHeaderContainerStyle={
          isPortfolioParityEnabled()
            ? styles.modalHeaderContainerStyle
            : BLANK_OBJECT
        }
      >
        {showUntagWarningModal && (
          <UIModal
            isOpen={showUntagWarningModal}
            modalContent={classes.untagWarningModalContainer}
          >
            <div className={classes.untagModalInnerContainer}>
              <div className={classes.untagWarningHeader}>
                {t("journal:untag_student_with_count", {
                  count: _.size(studentsToUntag),
                })}
                <IconButton
                  icon={<CloseOutlined />}
                  size="medium"
                  variant={"plain"}
                  onClick={() =>
                    this.setState({
                      showUntagWarningModal: false,
                      studentsToUntag: [],
                    })
                  }
                />
              </div>

              <div className={classes.untagWarningBody}>
                {t("journal:untag_student_warning_msg", {
                  count: _.size(studentsToUntag),
                })}
              </div>

              <div className={classes.untagWarningFooter}>
                <Button
                  variant={"outlined-subtle"}
                  size={"large"}
                  onClick={() =>
                    this.setState({
                      showUntagWarningModal: false,
                      studentsToUntag: [],
                    })
                  }
                  style={{ marginRight: "12px" }}
                >
                  {t("common:cancel")}
                </Button>
                <Button
                  variant={"destructive"}
                  size={"large"}
                  onClick={this.updatePostState}
                >
                  {t("journal:untag")}
                </Button>
              </div>
            </div>
          </UIModal>
        )}
        <div className={classes.container} ref={this.containerRef}>
          {!(_.isEmpty(students) && !searchText) && (
            <div className={classes.searchContainer}>
              <SearchInput
                dsVersion="2.0"
                value={searchText}
                placeholder={t("search_for_student")}
                onChange={this.onSearchTextChange}
                size={"large"}
                testId={"journal-postcreation-tagstudents-search"}
                focusSearchBySlash={true}
              />
            </div>
          )}
          <StudentList
            studentListRef={this.studentListRef}
            userInfo={userInfo}
            isData={isData}
            isLoading={isLoading}
            students={students}
            selectedStudentIds={selectedStudentIds}
            studentSelectionMode={studentSelectionMode}
            onItemCheckBoxClick={this.onItemCheckBoxClick}
            isAllSelected={isAllSelected}
            searchText={filters.searchText}
            showLoaderBar={false}
            showNewDesign={_.get(screenPanelProps, "showNewDesign", false)}
            showNewDesignV2={_.get(screenPanelProps, "showNewDesignV2", false)}
          />
        </div>
      </ScreenPanel>
    );
  }
}

const mapActionCreators = { updateStudentListFilters };

const mapStateToProps = (state, ownProps) => {
  const courseIdFromParent = _.get(
    ownProps,
    "screenPanelProps.postDetails.courseId"
  );
  const postIbPypElementRatings = _.get(
    state,
    "post.postDetails.originalibPYPElementRatings",
    []
  );
  const isStudentIndividuallyRated = _.get(
    state,
    "post.postDetails.originalIsStudentIndividuallyRated",
    false
  );

  const studentSelectionMode = _.get(
    ownProps,
    "studentSelectionMode",
    "MULTIPLE"
  );

  const defaultNameSortPreference = getDefaultNameSortPreference(state);

  const studentActivityData = _.get(
    state,
    "post.postDetails.studentActivityData",
    {}
  );
  const curriculumProgramType = getCurrentCurriculumProgramType(state);

  const createdBy = _.get(state, "post.postDetails.createdBy", BLANK_OBJECT);
  const academicYear = getSelectedAcademicYearId(state);

  const filters = _.merge(_.get(state, "post.studentListFilters", {}), {
    academicYear,
  });

  return {
    courseId: courseIdFromParent
      ? courseIdFromParent
      : state.teacher.selected_class.selected_course,
    filters,
    userInfo: state.login.userInfo,
    postId: _.get(ownProps, "screenPanelProps.postDetails.id"),
    postIbPypElementRatings,
    isStudentIndividuallyRated,
    studentSelectionMode,
    defaultNameSortPreference,
    studentActivityData,
    curriculumProgramType,
    createdBy,
    academicYear,
  };
};

export default compose(
  I18nHOC({ resource: ["journal", "common"] }),
  connect(mapStateToProps, mapActionCreators),
  graphql(getCourseFilteredStudentQuery, {
    name: "getCourseFilteredStudent",
    options: ({ courseId, filters, postId, academicYear }) => ({
      fetchPolicy: "cache-and-network",
      variables: {
        id: courseId,
        filters: getUpdatedArchivedFilters(filters, {
          entityType: "JOURNAL",
          entityId: postId,
        }),
        orderBy: getDefaultOrderBy({ type: STUDENT }),
        orderByDirection: ASC,
        userArchivedFilters: { academicYearId: academicYear },
      },
    }),
    props({
      getCourseFilteredStudent,
      ownProps: {
        courseId,
        filters,
        postId,
        userInfo: { id: userId, user_type: userType },
        academicYear,
      },
    }) {
      const data = getCourseFilteredStudentFromCache({
        courseId,
        filters: getUpdatedArchivedFilters(filters, {
          entityType: "JOURNAL",
          entityId: postId,
        }),
        orderBy: getDefaultOrderBy({ type: STUDENT }),
        orderByDirection: ASC,
        userArchivedFilters: { academicYearId: academicYear },
      });
      let students = _.get(data, "students.edges", []);
      // Arrange the students list for student with its name on top
      if (
        userType == "student" &&
        !_.isEmpty(_.get(data, "students.edges", []))
      ) {
        const student = _.find(_.get(data, "students.edges", []), item =>
          _.isEqual(item.node.id, userId)
        );

        const restStudents = _.filter(
          _.get(data, "students.edges", []),
          item => !_.isEqual(item.node.id, userId)
        );

        students = _.isEmpty(student)
          ? restStudents
          : [student, ...restStudents];
      }

      return {
        isData: !_.isEmpty(data),
        students,
        networkStatus: getCourseFilteredStudent.networkStatus,
        isLoading:
          getCourseFilteredStudent["networkStatus"] == 1 ||
          getCourseFilteredStudent["networkStatus"] == 2,
      };
    },
  })
)(TagStudents);
